import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { Form as FormComponent } from 'antd';
import { assocPath, equals } from 'ramda';

import RequiredFieldsContext from 'components/context/RequiredFieldsContext';
import { getRequiredFields } from 'utils/getRequiredFields';
import { scrollToInvalid } from 'helpers/scrollHelper';
import InitialValuesContext from 'components/context/InitialValuesContext';

const mutators = { ...arrayMutators };

export default (formOptions = {}) => WrappedComponent =>
    class FormWrapper extends Component {
        static propTypes = {
            formAction: PropTypes.oneOfType([
                PropTypes.object,
                PropTypes.func,
            ]),
            mapBeforeSubmit: PropTypes.func
        };

        constructor(props) {
            super(props);

            this.state = {
                initialValues: this.getInitialValues(props)
            };
        }

        componentDidUpdate(prev) {
            const initialValues = this.getInitialValues();

            if (!equals(initialValues, this.getInitialValues(prev))) {
                this.setState({ initialValues });
            }
        }

        getInitialValues = (props = this.props) => {
            return formOptions.mapPropsToValues ? formOptions.mapPropsToValues(props) : {};
		}

        onSubmit = values => {
            const { formAction } = this.props;
            const mapBeforeSubmit = this.props.mapBeforeSubmit || formOptions.mapBeforeSubmit;

            if (!formOptions.customSubmit) {
                const payload = mapBeforeSubmit ? mapBeforeSubmit(values, this.props) : values;
                const submit = formAction.dispatch ? formAction.dispatch : formAction;
                const error = formAction.dispatch ? formAction.meta.error : null;

                submit(payload, { error });
            }
        }

        handleSubmit = (e, handleSubmit) => {
            scrollToInvalid(formOptions.scrollToInvalid);
            handleSubmit(e);
        }

        validate = values => {
            let schema = formOptions.validationSchema;

            if (!schema) {
                return {};
            }

            if (typeof schema === 'function') {
                schema = schema(this.props, values);
            }

            try {
                schema.validateSync(values, { abortEarly: false });
            } catch (e) {
                return e.inner.reduce((errors, error) => assocPath(error.path.split('.'), error.message, errors), {});
            }
        }

        render() {
            const decorators = (formOptions.decorators || formOptions.decoratorsFromProps) ? (
                [formOptions.decorators || formOptions.decoratorsFromProps(this.props)]
            ) : null;

            return <InitialValuesContext.Provider value={this.state.initialValues}>
                <RequiredFieldsContext.Provider value={getRequiredFields(formOptions.validationSchema)}>
                    <Form
                        subscription={{ submitting: true, invalid: true, submitFailed: true, error: true, initialValues: true }}
                        onSubmit={this.onSubmit}
                        validate={this.validate}
                        mutators={mutators}
                        initialValues={this.state.initialValues}
                        decorators={decorators}
                        render={props =>
                            <FormComponent onFinish={e => this.handleSubmit(e, props.handleSubmit)} noValidate>
                                <WrappedComponent
                                    scrollToInvalid={ formOptions.customSubmit ? scrollToInvalid : null}
                                    {...this.props}
                                    {...props}
                                />
                            </FormComponent>
                        }
                    />
                </RequiredFieldsContext.Provider>
            </InitialValuesContext.Provider>;
        }
    }
